var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.267 15.858a1 1 0 00-.004-1.433l-.067-.065a1 1 0 00-1.396.003l-2.756 2.698L13.031 4a1 1 0 00-1.001-.999h-.122a1 1 0 00-.999 1.001l.014 13.023-2.727-2.645a1 1 0 00-1.396.004l-.067.065a1 1 0 00.004 1.433L12.014 21l5.253-5.142z",
    fill: "#9CA6AD"
  })));
};

export default SvgArrowDown;